import { ReactComponent as EyeIcon } from "../../../assets/eye.svg";

interface Props {
  record: any;
  handleView: (record: any) => void;
}

function EyeButton({ record, handleView }: Props) {
  return (
    <div
      style={{
        cursor: "pointer",
        marginRight: "10px",
        borderRadius: "50%",
        height: "30px",
        width: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#81BC3D",
      }}
    >
      <EyeIcon
        className="icon"
        id={`view-${record?.id}`}
        onClick={() => handleView(record)}
        stroke="white"
        style={{ width: "20px", height: "20px" }}
      />
    </div>
  );
}

export default EyeButton;
